

module.exports = __webpack_require__.stylable.create(
    "Tabs3122818413",
    {"classes":{"root":"Tabs3122818413__root"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    14,
    "Tabs3122818413",
    null
);
